import { SelectOption } from '@/components/ui/select/select.types'

export const generateTimeOptions = (intervalMinutes = 30): SelectOption<number>[] => {
  const options: SelectOption<number>[] = []

  for (let totalMinutes = 0; totalMinutes < 24 * 60; totalMinutes += intervalMinutes) {
    const hours24 = Math.floor(totalMinutes / 60)
    const minutes = totalMinutes % 60
    const period = hours24 >= 12 ? 'PM' : 'AM'
    let hours12 = hours24 % 12
    if (hours12 === 0) hours12 = 12

    const label = `${hours12}:${minutes.toString().padStart(2, '0')}${period}`
    options.push({ label, value: totalMinutes })
  }

  return options
}
